const smsFrom = '#SMSFrom';

export function getSMSFrom() {
  return $(smsFrom).val();
}

export function setSMSFrom(value) {
  return $(smsFrom).val(value);
}
